import React, { Component } from "react";
import styles from "./monitoringsTaskTripsBar.module.scss";
import { NavLink } from "react-router-dom";
import getDates from "../../../../shared/services/date.service";
import { withMonitoringTaskTrips } from "../../../../shared/containers/containerLogisticMonitoringsTaskTrips";
import TooltipWrapper from "../../../../shared/items/contols/tooltipWrapper";
import KeyIcon from "@mui/icons-material/Key";
import { states } from "../../../../reducers/queriesStates";
import Preloader from "../../../../shared/items/static/preloader";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import SyncIcon from "@mui/icons-material/Sync";
import ModalConfirmWindow from "../../../Contents/ModalComponents/ModalConfirmWindow";
import DeleteConfirm from "../../../Contents/ModalComponents/DeleteConfirm";
import SettingsIcon from "@mui/icons-material/Settings";
import { withAuth } from "../../../../shared/containers/containerAuth";

const muiIconStyle = {
  width: "18px",
};

class MonitoringsTaskTripsItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      unitByCompleted: null,
    };
  }

  onClickHandler() {
    const { onGetMonitoringsTaskTrip, item, monitoringTaskTrip } = this.props;

    if (monitoringTaskTrip === null || monitoringTaskTrip.id !== item.id) {
      onGetMonitoringsTaskTrip(item);
    }
  }

  onClickUpdateHandler() {
    const { onGetMonitoringsTaskTrip, item } = this.props;

    onGetMonitoringsTaskTrip(item);
  }

  onCompletedTaskHanleClick() {
    const { onCompletedMonitoringsTaskTrip } = this.props;
    const { unitByCompleted } = this.state;

    onCompletedMonitoringsTaskTrip({ id: unitByCompleted.taskTripId });
    this.setState({ unitByCompleted: null });
  }

  render() {
    const { item, monitoringTaskTrip, monitoringTaskTripDataState, data } = this.props;
    const { unitByCompleted } = this.state;

    const isSelect = monitoringTaskTrip !== null && item.id === monitoringTaskTrip.id;

    const completedPermission = data.permissions.includes(54003);
    const addUnitPermission = data.permissions.includes(54004);
    const addRoutePermission = data.permissions.includes(54005);

    const settingPemision = addUnitPermission && addRoutePermission;

    return (
      <div className={styles.monitoringTaskTripItemContainer}>
        <NavLink to={"/logistic/monitorings/" + item.id} className={styles.linkWrapper} onClick={this.onClickHandler.bind(this)}>
          <div className={styles.header}>
            <div className={styles.headerLine}>
              <div className={styles.leftPanel}>
                <b>{item.title}</b>
              </div>
              <div className={styles.rightPanel}>{item.isViolation ? "С нарушениями" : "Без нарушений"}</div>
            </div>

            <div className={styles.headerLine}>
              <div className={styles.leftPanel}>
                {getDates.getDateFormat8(item.timeStart)} - {getDates.getDateFormat8(item.timeEnd)}
              </div>
              <div className={styles.rightPanel}>
                {isSelect ? (
                  <div style={{ fontSize: "16px", paddingTop: "10px", display: "flex" }}>
                    <div>
                      {monitoringTaskTripDataState === states.REQUEST ? (
                        <div>
                          <Preloader size={15} />
                        </div>
                      ) : (
                        <TooltipWrapper title={"Обновить данные"} position="top">
                          <div onClick={this.onClickUpdateHandler.bind(this)} style={{ height: "18px" }}>
                            <SyncIcon fontSize={"inherit"} />
                          </div>
                        </TooltipWrapper>
                      )}
                    </div>
                    {settingPemision ? (
                      <div>
                        <TooltipWrapper title={"Открыть настройки рейса"} position="top">
                          <NavLink
                            to={"/logistic/monitorings/" + item.id + "/settings"}
                            className={styles.linkWrapper}
                            onClick={this.onClickHandler.bind(this)}
                          >
                            <div style={{ height: "18px" }}>
                              <SettingsIcon fontSize={"inherit"} />
                            </div>
                          </NavLink>
                        </TooltipWrapper>
                      </div>
                    ) : null}
                  </div>
                ) : null}
              </div>
            </div>
          </div>
          {isSelect ? (
            <div>
              {item.units.map((unit, index) => {
                return (
                  <div
                    key={unit.id + unit.isCompleted}
                    style={{ position: "relative", marginBottom: `${index < item.units.length - 1 ? "3px" : "0px"}` }}
                  >
                    <div className={styles.carsListItem}>
                      <div className={getStatusStyles(unit.lastState.status)}>
                        <span className={styles.title}>{unit.number}</span>
                      </div>

                      <div>
                        <div className={styles.dashboardPanelContainer}>
                          <div className={styles.carsListItemTitle}>{unit.title}</div>
                          <div className={styles.dashboardPanel}>{unit.isViolation ? "С нарушениями" : "Без нарушений"}</div>
                        </div>

                        <div className={styles.dashboardPanelContainer}>
                          <div>{unit.registerNumber}</div>

                          <div className={styles.dashboardPanel}>
                            <TooltipWrapper
                              title={
                                unit.isCompleted
                                  ? `Остлеживание рейса для ${unit.title} ${unit.registerNumber} завершено`
                                  : `Завершить отслеживание рейса для ${unit.title} ${unit.registerNumber}`
                              }
                              position="top"
                            >
                              <div className={styles.dashboardPanelItem} key={unit.id + unit.isCompeted}>
                                {!unit.isCompleted ? (
                                  <PowerSettingsNewIcon
                                    style={{ ...muiIconStyle, color: "#408ad4" }}
                                    onClick={(e) => {
                                      if (completedPermission) this.setState({ unitByCompleted: unit });
                                    }}
                                  />
                                ) : (
                                  <PowerSettingsNewIcon style={muiIconStyle} />
                                )}
                              </div>
                            </TooltipWrapper>

                            <TooltipWrapper title={unit.lastState.ignition ? "Зажигание включено" : "Зажигание выключено"} position="top">
                              <div className={styles.dashboardPanelItem}>
                                {unit.lastState.ignition ? (
                                  <KeyIcon style={{ ...muiIconStyle, color: "#f7bf47" }} />
                                ) : (
                                  <KeyIcon style={muiIconStyle} />
                                )}
                              </div>
                            </TooltipWrapper>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : null}
        </NavLink>

        {unitByCompleted !== null ? (
          <ModalConfirmWindow isOpen={unitByCompleted !== null}>
            <DeleteConfirm
              onConfirmHandle={() => {
                this.onCompletedTaskHanleClick();
              }}
              onNotConfirmHandle={(e) => {
                this.setState({ unitByCompleted: null });
              }}
              text={`Завершить отслеживание рейса для ${unitByCompleted.title} ${unitByCompleted.registerNumber} ?`}
            />
          </ModalConfirmWindow>
        ) : null}
      </div>
    );
  }
}

const getStatusStyles = (status) => {
  switch (status.id) {
    case -1:
      return styles.container_carNumber_noData;
    case 1:
      return styles.container_carNumber_inMove;
    case 0:
      return styles.container_carNumber_parking;
    default:
      return null;
  }
};

export default withAuth(withMonitoringTaskTrips(React.memo(MonitoringsTaskTripsItem)));
